import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
    state : {
        count : 0,
        userEmail : 'Guest',
        userImage : '',
        isLoggedIn : false,
        userDetails : {},
        ready : false,
        caplogs : [],
        myEdit : true,
        newEventualCapLog : {id:'', log : 'Creating new eventual log', updatedAt : ''}
    },
    mutations : {
        increment : function(state){
            state.count++
        },
        loggedIn(state,user){
            state.userEmail = user.email
            state.userImage = user.photoURL
            state.isLoggedIn = true;
            state.userDetails = user
        },
        loggedOut(state){
            state.userEmail = 'Guest'
            state.isLoggedIn = false
            state.userImage = ''
            state.userDetails = {}
            state.ready = false;
            state.caplogs = []            
        },
        ready(state){
            state.ready = true
        },
        removeLogs(state){
            state.caplogs = []
        },
        addLog(state,newLog){
            state.newEventualCapLog = newLog
        },
        updateEdit(state, updatedData){
            state.myEdit = updatedData.isInSync
            if(updatedData.logContent){
                this.state.newEventualCapLog.log = updatedData.logContent.log
            }
        },
        eventualCapLogReady(state, newEventualCapLog){
            state.newEventualCapLog = newEventualCapLog
        },
        pushNewEventualLogAfterIdle(state){
            if(state.newEventualCapLog){
                // state.caplogs.push(state.newEventualCapLog)               
                state.caplogs = [state.newEventualCapLog, ...state.caplogs]
                console.log("pushed: " + state.newEventualCapLog)
            }
        }
    },
    actions : {
        increment : function(context){
            context.commit('increment')
        },
        userLoggedIn({commit},user){
            commit('loggedIn',user)
        },
        userSignedOut({commit}){
            commit('loggedOut');
        },
        ready({commit}){
            commit('ready')
        },
        removeLogs({commit}){
            commit('removeLogs')
        },
        newLogSaved({commit},newLog){
            commit('addLog',newLog)
            commit('updateEdit',{isInSync : true})
        },
        updatedLogSaved({commit},updatedLog){
            commit('updateEdit',{isInSync : true, logContent : updatedLog});
        },
        editing({commit}){
            commit('updateEdit',false)
        },
        eventualCapLog({commit},newEventualCapLog){
            commit('eventualCapLogReady', newEventualCapLog)
        },
        // prepareForNewLog({commit}){
        //     commit('prepareForNewLog')
        // }
        pushNewEventualLogAfterIdle({commit}){
            commit('pushNewEventualLogAfterIdle')
        }
    },
    getters : {
        currentCount : state=>state.count
    }
})